// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PracticeDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class PracticeApiClient extends BaseCRUDApiClient<PracticeDto> {
  baseUrl = this.config.apiEndpoint + '/practice';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
